import * as React from "react"
import PropTypes from "prop-types"
import playstore from "../images/icons/playstore.svg"
import appstore from "../images/icons/appstore.svg"
import { css } from "@emotion/react"

const StoresButtons = ({ globals = {}, small = false }) => {
  return (
    <div className="flex justify-center">
      {globals.data.store?.map((store, i) => {
        switch (store.store_id) {
          case "applestore":
            return (
              <a key={i} href={store.link} target="_blank" rel="noreferrer">
                <div
                  css={cssButtonApp}
                  className={`flex items-center font-medium mx-2 rounded-full font-sans text-base shadow-md shadow-gray-200 px-4 py-4 ${
                    !small
                      ? "md:min-w-[170px]  md:px-7 md:py-5"
                      : "md:px-2 md:mx-0 md:mr-2 lg:px-5 "
                  } md:font-semibold`}
                >
                  <img
                    src={appstore}
                    alt="App Store"
                    className={`block w-4 h-4 lg:w-5 ${!small && "mr-3"} `}
                  />{" "}
                  {!small && " App Store"}
                </div>
              </a>
            )
          case "playstore":
            return (
              <a key={i} href={store.link} target="_blank" rel="noreferrer">
                <div
                  css={cssButtonApp}
                  className={`flex items-center font-medium mx-2 rounded-full font-sans text-base shadow-md shadow-gray-200 px-4 py-4 ${
                    !small
                      ? "md:min-w-[170px]  md:px-7 md:py-5"
                      : "md:px-2 md:mx-0 lg:px-5  "
                  } md:font-semibold`}
                >
                  <img
                    src={playstore}
                    alt="Play Store"
                    className={` w-4 h-4 lg:w-5 ${!small && "mr-3"} `}
                  />
                  {!small && " Play Store"}
                </div>
              </a>
            )
          default:
            break
        }
      })}
    </div>
  )
}

const cssButtonApp = css`
  background: linear-gradient(360deg, #fafafa 0%, #ffffff 60.42%);
`

StoresButtons.propTypes = {
  globals: PropTypes.object.isRequired,
  small: PropTypes.bool,
}

export default StoresButtons
